<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 1600 800"
  class="min-w-screen fixed left-0 top-0 min-h-screen"
  preserveAspectRatio="none">
  <rect [attr.fill]="'var(--primary-500)'" width="1600" height="800" />
  <g clip-path="url(#clip0_355_16217)">
    <path d="M1620 0H-180V900H1620V0Z" fill="#E3E8F0" />
    <path
      d="M358.2 653.625C361.8 654.525 365.4 655.537 368.888 656.438C589.612 715.5 806.175 806.625 1036.58 855.112C1232.55 896.287 1429.76 887.963 1620 843.638V0H-180V646.763C-121.163 626.963 -60.1875 615.6 1.2375 612C121.95 604.575 242.663 623.475 358.2 653.625Z"
      fill="#DFE7EF" />
    <path
      d="M24.525 291.825C135 298.575 240.413 331.425 340.987 372.938C344.138 374.175 347.175 375.525 350.325 376.762C542.7 457.312 735.862 555.075 948.037 610.425C1171.69 668.7 1401.86 656.325 1620 593.775V0H-180V318.6C-113.625 296.55 -44.325 287.663 24.525 291.825Z"
      fill="#EFF3F8" />
    <path
      d="M331.762 97.0875C495.787 199.125 665.55 302.962 859.612 365.625C1094.29 441.45 1344.82 434.025 1577.25 359.663C1591.65 355.05 1605.82 350.212 1620.11 345.15V0H144.112C207.112 23.9625 266.4 56.925 323.775 92.25C326.475 93.825 329.062 95.5125 331.762 97.0875Z"
      fill="#F6F9FC" />
    <path
      d="M1392.19 174.15C1445.29 162.225 1497.49 145.688 1548.11 124.875C1572.53 114.863 1596.49 103.725 1620 91.6875V0H543.825C614.588 46.9125 689.738 87.975 771.188 120.825C967.95 200.363 1185.98 220.613 1392.19 174.15Z"
      fill="white" />
  </g>
  <defs>
    <clipPath id="clip0_355_16217">
      <rect width="1800" height="900" fill="white" transform="translate(-180)" />
    </clipPath>
  </defs>
</svg>
